import { myinfoQueries } from "@app/config/queryFactory";
import { cn } from "@base/lib/utils";
import { adminQueries } from "@features/admin/api/queryFactory";
import type { MemberStatus, MemberType } from "@features/admin/model/types";
import { MyInfoTabs } from "@features/myinfo/ui";
import { BaseLayout } from "@layouts/ui";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

const MEMBER_TYPES: MemberType[] = [
  "SILVER_MONTHLY",
  "SILVER_YEARLY",
  "VIRTUAL_ADDRESS_MONTHLY",
  "VIRTUAL_ADDRESS_YEARLY",
  "DAY_PASS",
];

// 화면에 존재하는 상태는 Active와 Expired 두 가지뿐이므로 PAST_DUE는 받지 않는다.
const MEMBER_STATUSES: MemberStatus[] = ["ACTIVE", "CANCELLED"];

export interface MyInfoSearch {
  page?: number;
  company_name?: string;
  type?: MemberType;
  status?: MemberStatus;
}

export const Route = createFileRoute("/_authenticated/myinfo")({
  validateSearch: (search: Record<string, unknown>): MyInfoSearch => {
    const page = Number(search.page);
    const type = search.type as MemberType;
    const status = search.status as MemberStatus;
    const companyName = typeof search.company_name === "string" ? search.company_name : undefined;

    return {
      page: Number.isFinite(page) && page >= 1 ? Math.floor(page) : undefined,
      company_name: companyName || undefined,
      type: MEMBER_TYPES.includes(type) ? type : undefined,
      status: MEMBER_STATUSES.includes(status) ? status : undefined,
    };
  },
  // 멤버 검색/필터가 같은 라우트 내 search param 네비게이션으로 구현되어 있어, staleTime이 없으면
  // 검색/필터할 때마다 loader가 재실행되어 멤버 검색과 무관한 profile API가 함께 재호출된다.
  staleTime: 30 * 1000,
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(myinfoQueries.profile());

    return null;
  },
  component: MyInfoPage,
});

function MyInfoPage() {
  const { data: adminStatus } = useQuery(adminQueries.status());
  // 관리자 뷰는 멤버 테이블과 예약 현황을 넓게 보여줘야 하므로 유저 뷰(816px)보다 넓은 컨테이너를 쓴다.
  const isAdmin = adminStatus?.admin === true;

  return (
    <BaseLayout>
      <div className="min-h-[calc(100vh-58px)] md:min-h-[calc(100vh-80px)] py-8">
        <div className={cn("w-full mx-auto px-4", isAdmin ? "max-w-[1280px]" : "max-w-[816px]")}>
          <MyInfoTabs />
        </div>
      </div>
    </BaseLayout>
  );
}
